import { render } from "./Financiamiento.vue?vue&type=template&id=87fbaacc&scoped=true"
import script from "./Financiamiento.vue?vue&type=script&lang=js"
export * from "./Financiamiento.vue?vue&type=script&lang=js"

import "./Financiamiento.vue?vue&type=style&index=0&id=87fbaacc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87fbaacc"]])

export default __exports__